import { Injectable} from '@angular/core';
import {HttpInterceptorService} from '../../../../core/services/http-interceptor.service';
import {DiagnosticOrder} from '../../classes/DiagnosticOrder';
import {WorkflowConfigService} from "../../../../workflow-config/services/workflow-config.service";
import {TestService} from "../test.service";
import * as _ from 'lodash';
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {PreviewService} from "@ispm/test/services/preview/preview.service";
import {NotificationStoreHandler} from "@ispm/shared/notification/service/notification-store-handler";
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {DiagnosticOrderActionsService} from "@ispm/test/services/diagnostic-order-actions.service";
import { DiagnosticOrderService } from '../diagnostic-order.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {WorkflowService} from "@ispm/workflow/services/workflow.service";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {Router, ActivatedRoute} from '@angular/router';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Injectable()
export class PathwayPreviewService extends PreviewService {


  constructor(protected workflowConfigService: WorkflowConfigService,
              protected diagnosticOrderService: DiagnosticOrderService,
              protected authService: AuthenticationService,
              protected testService: TestService,
              protected diagnosticOrderActionsService: DiagnosticOrderActionsService,
              protected http: HttpInterceptorService,
              protected state: Router,
              public notificationMessageService: NotificationMessageService,
              protected store: Store<IgenomicsState>,
              protected notificationStoreHandler: NotificationStoreHandler,
              protected coreAC: CoreActionCreatorService,
              protected workflowService: WorkflowService,
              protected routerManagerService: RouterManagerService) {
    super(workflowConfigService, diagnosticOrderService, authService, testService, diagnosticOrderActionsService, http, state, notificationMessageService, store, notificationStoreHandler,coreAC,workflowService, routerManagerService);


  }

  protected setDiagnosticOrderParameters(curationData, curationStatus, knowledgeBase, diagnosticOrder): DiagnosticOrder {
    let workflowRequestDescr = _.get(curationData, 'context').find(entry =>
      _.get(entry, 'resourceType').toLowerCase() === 'WorkflowRequest'.toLowerCase());
    diagnosticOrder.disease = {
      code: _.get(curationData, 'content.disease.code'),
      curationDataId: curationData.id,
      display: _.get(curationData, 'content.disease.display'),
      revisionId: _.get(curationData, 'revisionId'),
      revisionName: _.get(curationData, 'revisionName'),
      deploymentId: _.get(curationData, 'content.bpmn.bpmnIdentifier.deploymentId'),
      workflowRequestId: (workflowRequestDescr ? workflowRequestDescr.reference : undefined),
      curationStatus: curationStatus
    };

    _.set(diagnosticOrder, 'kb', knowledgeBase);

    diagnosticOrder.discipline = _.get(curationData, 'content.discipline');

    return diagnosticOrder;
  }

}
